import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { Column } from "../../cms/objects/column";
import {
    EMPTY_CLIENT_DEMAND_LIST_CONFIGURATION,
    EMPTY_CLIENT_DEMAND_LIST_CRITERIA,
} from "../constant/clientDemandConstant";
import { ClientDemand, ClientDemandListConfiguration, ClientDemandListCriteria } from "../objects/clientDemand";

export interface ClientDemandState {
    client_demand_list: ClientDemand[];
    client_demand_list_configuration: ClientDemandListConfiguration;
    client_demand_list_count: number;
    client_demand_list_loading: boolean;
    client_demand_list_criteria: ClientDemandListCriteria;
    client_demand_refresh: boolean;
}

const initialState: ClientDemandState = {
    client_demand_list: [],
    client_demand_list_configuration: EMPTY_CLIENT_DEMAND_LIST_CONFIGURATION,
    client_demand_list_count: 0,
    client_demand_list_loading: false,
    client_demand_list_criteria: EMPTY_CLIENT_DEMAND_LIST_CRITERIA,
    client_demand_refresh: false,
};

const updateClientDemandListReducer = (state: ClientDemandState, action: PayloadAction<ClientDemand[]>): ClientDemandState => ({
    ...state, client_demand_list: action.payload || []
});
const updateClientDemandListCountReducer = (state: ClientDemandState, action: PayloadAction<number>): ClientDemandState => ({
    ...state, client_demand_list_count: action.payload
});
const updateClientDemandListLoadingReducer = (state: ClientDemandState, action: PayloadAction<boolean>): ClientDemandState => ({
    ...state, client_demand_list_loading: action.payload
});
const updateClientDemandListCriteriaReducer = (state: ClientDemandState, action: PayloadAction<ClientDemandListCriteria>): ClientDemandState => ({
    ...state, client_demand_list_criteria: action.payload
});
const toggleClientDemandRefreshReducer = (state: ClientDemandState): ClientDemandState => ({
    ...state, client_demand_refresh: !state.client_demand_refresh
});
const updateClientDemandInListReducer = (state: ClientDemandState, action: PayloadAction<ClientDemand>): ClientDemandState => ({
    ...state, client_demand_list: state.client_demand_list.map(d => d.id === action.payload.id ? action.payload : d)
});
const setClientDemandColumnsReducer = (state: ClientDemandState, action: PayloadAction<Column[]>): ClientDemandState => ({
    ...state, client_demand_list_configuration: { ...state.client_demand_list_configuration, columns: action.payload }
});
const toggleClientDemandColumnReducer = (state: ClientDemandState, action: PayloadAction<number>): ClientDemandState => {
    const columns = cloneDeep([...state.client_demand_list_configuration.columns]);
    const column = { ...columns[action.payload] };
    column.checked = !column.checked;
    columns[action.payload] = column;
    return { ...state, client_demand_list_configuration: { ...state.client_demand_list_configuration, columns } };
};

export const clientDemandSlice = createSlice({
    name: 'clientDemand',
    initialState,
    reducers: {
        updateClientDemandList: updateClientDemandListReducer,
        updateClientDemandListCount: updateClientDemandListCountReducer,
        updateClientDemandListLoading: updateClientDemandListLoadingReducer,
        updateClientDemandListCriteria: updateClientDemandListCriteriaReducer,
        toggleClientDemandRefresh: toggleClientDemandRefreshReducer,
        updateClientDemandInList: updateClientDemandInListReducer,
        setClientDemandColumns: setClientDemandColumnsReducer,
        toggleClientDemandColumn: toggleClientDemandColumnReducer,
    },
});

export const {
    updateClientDemandList,
    updateClientDemandListCount,
    updateClientDemandListLoading,
    updateClientDemandListCriteria,
    toggleClientDemandRefresh,
    updateClientDemandInList,
    setClientDemandColumns,
    toggleClientDemandColumn,
} = clientDemandSlice.actions;
